import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import * as routes from '../../infrastructure/routemap';
import { SessionConsumer } from '../components/SessionProvider';
import LoadingSession from '../views/LoadingSession';

class Logout extends Component {
    render() {
        return (
            <SessionConsumer>
                {({ logout, ready, loggedIn }) => {
                    loggedIn && logout();
                    return (
                        <React.Fragment>
                            { ready && !loggedIn && <Redirect to={routes.root} />}
                            <LoadingSession />
                        </React.Fragment>
                    );
                }}
            </SessionConsumer>
        );
    }
}

export default Logout;